import React from 'react'
import PropTypes from 'prop-types'

import InformationIcon from 'assets/icons/information.png'

function HelpDialog({ description, title }) {
  return (
    <div className="help-dialog">
      <div className="help-dialog__title">
        <img src={InformationIcon} alt="Help" className="help-dialog__icon" />
        {title}
      </div>
      {description}
    </div>
  )
}

HelpDialog.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default HelpDialog
